import { useEffect } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useIsTouch } from '../../hooks/useMediaQuery';

export const SortableHeader = ({ id, children, disabled }) => {
    // Touch: keep touch-action auto (below) so horizontal swipes scroll the grid
    // Drag: start via a long-press on the handle (TouchSensor)
    const isTouch = useIsTouch();

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: id,
        data: {
            type: 'Column',
            colId: id,
        },
        disabled: disabled
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        position: 'relative',
        zIndex: isDragging ? 9991 : 'auto',
        opacity: isDragging ? 0.8 : 1,
        backgroundColor: isDragging ? '#ffffff' : 'transparent',
        boxShadow: isDragging ? '0px 2px 8px rgba(0,0,0,0.15)' : 'none',
        borderRadius: isDragging ? '4px' : '0',
        cursor: isDragging ? 'grabbing' : 'default',
        touchAction: isTouch ? 'auto' : 'none'
    };

    // Synchronize this column's CSS transform with all of its cells
    useEffect(() => {
        const cells = document.querySelectorAll(`[data-sync-col="${id}"]`);
        const transformString = CSS.Translate.toString(transform);

        cells.forEach(cell => {
            cell.style.transform = transformString || '';
            cell.style.transition = transition || '';
            cell.style.position = isDragging ? 'relative' : '';
            cell.style.zIndex = isDragging ? '9991' : '';
            cell.style.opacity = isDragging ? '0.6' : '';
            cell.style.backgroundColor = isDragging ? '#ffffff' : '';
        });
    }, [transform, transition, isDragging, id]);

    return (
        <div
            ref={setNodeRef}
            style={style}
            // Touch: the whole column header is the drag activator (long-press)
            // Desktop: listeners go to the handle as before
            {...(isTouch ? listeners : {})}
        >
            {typeof children === 'function'
                ? children({ listeners: isTouch ? {} : listeners, attributes })
                : children
            }
        </div>
    );
};
